var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    {
      attrs: {
        center: !_vm.isAllowed,
        grow: "",
        "no-margin": "",
        "no-padding": "",
      },
    },
    [
      _vm.isAllowed
        ? _c(
            "w-col",
            { attrs: { xs: "12", "no-margin": "", "no-padding": "" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("titles.extra-fields"))),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c("app-extra-fields-edit", {
                        attrs: {
                          value: _vm.value,
                          "name-settings": _vm.settings,
                          "tab-id": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("app-missing-module", { attrs: { "module-id": _vm.moduleId } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }